import * as Common from '@/tenant/common';

export class OrderItem extends Common.StateObject2{
  constructor(){
    super('OrderItem')
    this.binders.order = new Common.ModelBinder(Common.Order);
    this.binders.commodity = new Common.ModelBinder(Common.Commodity);
    this.binders.sku = new Common.ModelBinder(Common.SKU);
    this.binders.supplier = new Common.ModelBinder(Common.Counterpart);
  }
  public id: number = 0;
  public salesPurchaseFlag: number = 0;
  public orderNo: string = '';
  public order: Common.Order = null;
  public seqNo: number = 0;
  // public salesOrderItemId: number = null;
  public salesOrderItemNo:string='';
  public salesRefNo: string = '';
  public orderItemNo: string = '';

  // public get workflowHolder():string{
  //   if (this.state == Common.OrderItemStatus.PurchaseOrderCompleted ||
  //       this.state == Common.OrderItemStatus.SalesOrderCompleted) return '';
  //   else if (this.order) return this.order.workflowHolder;
  //   else return super.workflowHolder;
  // }
  // public set workflowHolder(value:string){
  //   super.workflowHolder = value;
  // }
  // 商品
  public commodityId: number = 0;
  public commodity: Common.Commodity = null;
  public commodityName: string = '';
  public sellingPrice: number = 0;
  public purchasePrice: number = 0;
  public package: string = null;
  public uom: Common.Conversion = null;
  public set uom2(conv : Common.Conversion){
    if(conv == null || conv.code == null) this.uom = null;
    else this.uom = conv;
  }
  public get uom2(): Common.Conversion{
    if(this.uom != null)return this.uom;
    if(this.commodity != null)return this.commodity.getDefaultConversion();
  }
  public skuId: number = null;
  public sku: Common.SKU = null;

  // 数量
  public quantity: number = 0;
  public allocatedQuantity: number = 0;
  public purchaseOrderdQuantity: number = 0;
  public purchaseDeliveringQuantity: number = 0;
  public purchaseDeliverdQuantity: number = 0;
  public closedQuantity: number = 0;
  public backSalesOrderQuantity: number = 0;
  public deliveringQuantity:number = 0;
  public regularlyQuantity:number = 0;
  public purchasePendingQuantity:number = 0;
  // 金額
  public unitPrice: number = 0;
  public dealAmountFC: number = 0;
  public amountFC: number = 0;
  public taxAmountFC: number = 0;
  public totalAmountFC: number = 0;
  public get calcGrossProfit(): number{
    return this.commodity ? this.amountFC - (this.purchasePrice * this.quantity * this.uom2.rate) : this.amountFC;
  }
  public taxCode: string = '';
  
  // 仕入先詳細
  public supplierId: number = null;
  public supplier: Common.Counterpart = null;
  
  // その他
  public isNCV: boolean = false;
  public description: string = '';
  public salesCustomerOrderNo: string = '';
  public itemRequestDate: Date = null;
  public answerDeliveryDate: Date = new Date().getCalendarDate();
  public scheduledDeliveryDate: Date = new Date().getCalendarDate();
  public backOrderQuantity: number = 0;
  
  // 予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1: Date = null;
  public reserveDate2: Date = null;
  public reserveDate3: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;

  //サブスクリプション
  public subscriptionStartDate: Date = null;
  public subscriptionEndDate: Date = null;       
  public monthlyQuantity: number = 0;    
  public nextSettlementDate: Date = null;

  //明細タブ用のプロパティ
  public get salesOrderNo() {
    if (this.salesOrderItemNo && this.salesOrderItemNo.indexOf('-') > 0)return this.salesOrderItemNo.split('-')[0];
    else return '';
  }

  public get linkOrder() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesOrder?orderNo={0}', this.orderNo);
      else return String.format('/purchase/PurchaseOrder?orderNo={0}', this.orderNo);
  }
  public get linkOrderItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) return String.format('/sales/SalesOrderItem?orderItemNo={0}', this.orderItemNo);
      else return String.format('/purchase/PurchaseOrderItem?orderItemNo={0}', this.orderItemNo);
  }  
  public get linkSalesOrder() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return String.format('/sales/SalesOrder?orderNo={0}', this.salesOrderNo);
      else return '';
  }
  public get linkSalesOrderItem() {
      if (this.salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase) return String.format('/sales/SalesOrderItem?orderItemNo={0}', this.salesOrderItemNo);
      else '';
  }  

  get isNoStock():boolean{
    return this.commodity != null ? this.commodity.isNoStock : false;
  }

  // 受発注明細一覧のメニューから複製がなくなったため、コメントアウト
  // 仕様確定時に引き続き不要であれば削除する
  //public copy():any {
  //  const temp = super.copy() as OrderItem;
  //  temp.id = 0;
  //  return temp;
  //}

  public onChangeCommodity(tenantSettings: Common.TenantSettings){
    if(this.commodity == null){
      this.commodityName = '';
      this.package = null;
      this.uom = null;
      this.supplier = null;
      this.description = '';
      this.unitPrice = 0;
      this.taxCode = '';
      this.reserveText1 = '';
      this.reserveText2 = '';
      this.reserveText3 = '';
      this.reserveText4 = '';
      this.reserveText5 = '';
      this.reserveText6 = '';
      this.reserveMemo1 = '';
      this.reserveMemo2 = '';
      this.reserveMemo3 = '';
      this.reserveList1 = null;
      this.reserveList2 = null;
      this.reserveList3 = null;
    }
    else{
      this.commodityName = this.commodity.name;
      this.package = '';
      this.uom = null;
      this.supplier = this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales ? this.commodity.supplier : null;
      this.description = this.commodity.description;
      this.sellingPrice = this.commodity.sellingPrice;
      this.purchasePrice = this.commodity.purchasePrice;
      if(tenantSettings.usedTypeDetailReserveText1 == Common.UsedTypes.OrderMemo) this.reserveText1 = this.commodity.reserveText1;
      if(tenantSettings.usedTypeDetailReserveText2 == Common.UsedTypes.OrderMemo) this.reserveText2 = this.commodity.reserveText2;
      if(tenantSettings.usedTypeDetailReserveText3 == Common.UsedTypes.OrderMemo) this.reserveText3 = this.commodity.reserveText3;
      if(tenantSettings.usedTypeDetailReserveText4 == Common.UsedTypes.OrderMemo) this.reserveText4 = this.commodity.reserveText4;
      if(tenantSettings.usedTypeDetailReserveText5 == Common.UsedTypes.OrderMemo) this.reserveText5 = this.commodity.reserveText5;
      if(tenantSettings.usedTypeDetailReserveText6 == Common.UsedTypes.OrderMemo) this.reserveText6 = this.commodity.reserveText6;
      if(tenantSettings.usedTypeDetailReserveMemo1 == Common.UsedTypes.OrderMemo) this.reserveMemo1 = this.commodity.reserveMemo1;
      if(tenantSettings.usedTypeDetailReserveMemo2 == Common.UsedTypes.OrderMemo) this.reserveMemo2 = this.commodity.reserveMemo2;
      if(tenantSettings.usedTypeDetailReserveMemo3 == Common.UsedTypes.OrderMemo) this.reserveMemo3 = this.commodity.reserveMemo3;
      if(tenantSettings.usedTypeDetailReserveList1 == Common.UsedTypes.OrderMemo) this.reserveList1 = this.commodity.reserveList1;
      if(tenantSettings.usedTypeDetailReserveList2 == Common.UsedTypes.OrderMemo) this.reserveList2 = this.commodity.reserveList2;
      if(tenantSettings.usedTypeDetailReserveList3 == Common.UsedTypes.OrderMemo) this.reserveList3 = this.commodity.reserveList3;
    }
  }
  public get messageOnEdit():string { 
    if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales)
      return 'ワークフローが進行しているため編集できません。\r\n受注伝票のワークフローのボタンを操作し、状態を「見積提示待ち」に戻してから編集してください。';
    else
      return 'ワークフローが進行しているため編集できません。\r\n発注伝票のワークフローのボタンを操作し、状態を「発注確定待ち」に戻してから編集してください。';
  }
  public get messageOnDelete():string {
    if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales)
      return 'ワークフローが進行しているため削除できません。\r\n受注伝票のワークフローのボタンを操作し、状態を「見積提示待ち」に戻してから削除してください。';
    else
      return 'ワークフローが進行しているため削除できません。\r\n発注伝票のワークフローのボタンを操作し、状態を「発注確定待ち」に戻してから削除してください。';
  }
}


export enum OrderItemStatus
{
  SalesOrder = 1, // 受注
  PurchaseOrder = 2, // 発注

  SalesOrderSaving = SalesOrder + 16, // 見積提示待ち
  SalesOrderWaiting = SalesOrder + 32, // 受注確定待ち
  SalesOrderLost = SalesOrder + 64, // 失注
  SalesOrderReceiptWaiting = SalesOrder + 128, // 入金処理待ち
  SalesOrderPartialReceiptWaiting = SalesOrder + 256, // 入金処理中
  SalesOrderUnallocated = SalesOrder + 512, // 出荷処理待ち
  SalesOrderAllocating = SalesOrder + 1024, // 出荷処理中
  SalesOrderAllocatingArrivalWaiting = SalesOrder + 2048,// 引当中/ 入荷待ち=>未使用
  SalesOrderArrivalWaiting = SalesOrder + 4096, // 入荷待ち
  SalesOrderUndelivered = SalesOrder + 8192, // 出荷開始待ち=>未使用
  SalesOrderDelivering = SalesOrder + 16384, // 出荷待ち=>未使用
  SalesOrderInstructionWaiting = SalesOrder + 32768,//=>出荷指示待ち
  SalesOrderCompleted = SalesOrder + 65536, // 完了
  SalesOrderNotCompleted = SalesOrderSaving | SalesOrderWaiting | SalesOrderReceiptWaiting | SalesOrderPartialReceiptWaiting | SalesOrderUnallocated | SalesOrderAllocating | SalesOrderAllocatingArrivalWaiting | SalesOrderArrivalWaiting | SalesOrderUndelivered | SalesOrderDelivering | SalesOrderInstructionWaiting, 
  SalesOrderOpen = SalesOrderReceiptWaiting | SalesOrderPartialReceiptWaiting | SalesOrderUnallocated | SalesOrderAllocating | SalesOrderAllocatingArrivalWaiting | SalesOrderArrivalWaiting |SalesOrderUndelivered | SalesOrderDelivering  | SalesOrderInstructionWaiting,//受注残あり
  
  PurchaseOrderSaving = PurchaseOrder + 16, // 発注確定待ち
  PurchaseOrderPaymentWaiting = PurchaseOrder + 32, // 支払処理待ち
  PurchaseOrderPartialPaymentWaiting = PurchaseOrder + 64, // 支払処理中
  PurchaseOrderUndelivered = PurchaseOrder + 128, // 入荷処理待ち
  PurchaseOrderDelivering = PurchaseOrder + 256, // 入荷処理中
  PurchaseOrderCompleted = PurchaseOrder + 512, // 完了
  PurchaseOrderNotCompleted = PurchaseOrderSaving | PurchaseOrderPaymentWaiting | PurchaseOrderPartialPaymentWaiting | PurchaseOrderUndelivered | PurchaseOrderDelivering,
  PurchaseOrderOpen = PurchaseOrderPaymentWaiting | PurchaseOrderPartialPaymentWaiting | PurchaseOrderUndelivered | PurchaseOrderDelivering, //発注残あり
}

export class SalesOrderItem extends OrderItem{
  constructor(){
    super()
    this.salesPurchaseFlag = 1;
    // this.workflowCode="salesOrderItem";
    this.state = 1;
    // this.workflowStateId = 1;
  }


  // 受発注明細一覧のメニューから複製がなくなったため、コメントアウト
  // 仕様確定時に引き続き不要であれば削除する
  //public copy():any {
  //  const temp = super.copy() as SalesOrderItem;
  //  temp.state = 1;
  //  temp.workflowStateId = 1;
  //  return temp;
  //}
}

export class OrderItemQuery extends Common.LoadQuery {
  constructor(salesPurchaseFlag: Common.SalesPurchaseFlags){
    super('OrderItemQuery',salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? PurchaseOrderItem : SalesOrderItem);
    this.salesPurchaseFlag = salesPurchaseFlag;
    this.state = salesPurchaseFlag == Common.SalesPurchaseFlags.Purchase ? Common.OrderItemStatus.PurchaseOrderNotCompleted : Common.OrderItemStatus.SalesOrderNotCompleted;
    this.sort = 'orderItemNo';
  }
  public get binder(): Common.ModelBinder {
    var binder = super.binder;
    binder.createInstance = ()=>new OrderItemQuery(this.salesPurchaseFlag);    
    return binder;
  }
  public salesPurchaseFlag: Common.SalesPurchaseFlags = Common.SalesPurchaseFlags.Purchase;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public pic: string = '';
  public currencyCode:string='';
  public commodity: Common.Commodity = null;
  public sku: Common.SKU = null;  
  public subscriptionEndDate: Date = null;
  public orderNo: string = '';
  public orderItemNo: string = '';
  public salesOrderItemNo: string = '';
  public refNo: string = '';
  public customerOrderNo: string = '';
  public commodityName: string ="";
  public description: string ="";
  public orderDateFrom: Date = null;
  public orderDateTo: Date = null;
  public answerDeliveryDateFrom: Date = null;
  public answerDeliveryDateTo: Date = null;
  public scheduledDeliveryDateFrom: Date = null;
  public scheduledDeliveryDateTo: Date = null;

  // 日付フラグ
  public orderDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public orderDateToFlag: Common.dateFlags = Common.dateFlags.default;
  public answerDeliveryDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public answerDeliveryDateToFlag: Common.dateFlags = Common.dateFlags.default;
  public scheduledDeliveryDateFromFlag: Common.dateFlags = Common.dateFlags.default;
  public scheduledDeliveryDateToFlag: Common.dateFlags = Common.dateFlags.default;
  public initialSavedOnFrom: Date = null;
  public initialSavedOnTo: Date = null;
  public lastUpdatedOnFrom: Date = null;
  public lastUpdatedOnTo: Date = null;
  public state: Common.OrderItemStatus = Common.OrderItemStatus.SalesOrderNotCompleted;
  public holder: string = '';
  public partialInclude:boolean = false;  

  //予備項目
  public reserveText1: string = '';
  public reserveText2: string = '';
  public reserveText3: string = '';
  public reserveText4: string = '';
  public reserveText5: string = '';
  public reserveText6: string = '';
  public reserveMemo1: string = '';
  public reserveMemo2: string = '';
  public reserveMemo3: string = '';
  public reserveDate1From: Date = null;
  public reserveDate1To: Date = null;
  public reserveDate2From: Date = null;
  public reserveDate2To: Date = null;
  public reserveDate3From: Date = null;
  public reserveDate3To: Date = null;
  public reserveList1: number = null;
  public reserveList2: number = null;
  public reserveList3: number = null;    
}

export class AllocateQuery extends Common.Query {
    constructor(){
        super('AllocateQuery',new Common.ModelBinder(OrderItem,false));
    }
    public orderItem: OrderItem = null;
    public stockBalances: Array<Common.StockBalance>;
}

export enum AllocationOrder
{
  OrderDate = 1, // 受注日
  OrderNo =2, // 受注番号
}

export enum StockOrder
{
  SKU = 1, // SKU
  DetailReserveText1 = 11, // 予備テキスト1
  DetailReserveText2 = 12, // 予備テキスト2
  DetailReserveText3 = 13, // 予備テキスト3
  DetailReserveText4 = 14, // 予備テキスト4
  DetailReserveText5 = 15, // 予備テキスト5
  DetailReserveText6 = 16, // 予備テキスト6
  DetailReserveMemo1 = 21, // 予備メモ1
  DetailReserveMemo2 = 22, // 予備メモ2
  DetailReserveMemo3 = 23, // 予備メモ3
  DetailReserveList1 = 31, // 予備リスト1
  DetailReserveList2 = 32, // 予備リスト2
  DetailReserveList3 = 33, // 予備リスト3
  DetailReserveDate1 = 41, // 予備日付1
  DetailReserveDate2 = 42, // 予備日付2
  DetailReserveDate3 = 43, // 予備日付3
}

export class BulkAllocateQuery extends Common.Query {
    constructor(orderItems:Array<OrderItem>){
        super('BulkAllocateQuery', new Common.ModelBinder(AllocateCount, false));
        this.orderItems = orderItems;
    }
    public orderItems: Array<Common.OrderItem> = new Array();
    public warehouse: Common.Counterpart = null;
    public orderByOrderItem: AllocationOrder = AllocationOrder.OrderDate;
    public adOrderItem: boolean = true;
    public orderByStock: StockOrder = StockOrder.SKU;
    public adStock: boolean = true;
}

export class AllocateCount extends Common.ObjectBase{
  constructor(){
    super(' ');
  }
  public cntSelect: number;
  public cntSuccess: number;
}

export class PurchaseOrderItem extends OrderItem{
  constructor(){
    super()
    this.salesPurchaseFlag = 0;
    // this.workflowCode="purchaseOrderItem";
    this.state = 4096;
    // this.workflowStateId = 4096;
  }

  // 受発注明細一覧のメニューから複製がなくなったため、コメントアウト
  // 仕様確定時に引き続き不要であれば削除する
  //public copy():any {
  //  const temp = super.copy() as PurchaseOrderItem;
  //  temp.state = 4096;
  //  temp.workflowStateId = 4096;
  //  return temp;
  //}
}

export class UpdateDeliveryDateQuery extends Common.Query {
    constructor(){
        super('UpdateDeliveryDateQuery',new Common.ModelBinder(OrderItem,false));
    }
    public orderItems: Array<Common.OrderItem>;
    public answerDeliveryDate :Date;
    public scheduledDeliveryDate: Date;
}

export class UpdateSubscriptionEndDateQuery extends Common.Query {
    constructor(){
        super('UpdateSubscriptionEndDateQuery',new Common.ModelBinder(OrderItem,false));
    }
    public orderItems: Array<Common.OrderItem>;
    public subscriptionEndDate :Date;
}

export class CreatePuchaseOrderQuery extends Common.Query {
    constructor(){
        super('CreatePuchaseOrderQuery',new Common.ModelBinder(Common.Order,true));
    }
    public isBulkOrder: boolean;
    public salesOrders: Array<Common.SalesOrder>;
    public salesOrderItems: Array<Common.OrderItem>;
    public pic: string;
    public counterpart: Common.Counterpart;
    public isOverwrite: boolean;
    public deliveryFlag: Common.DeliveryFlags;
    public workflowId: number=0;    
    public actionId: number=0;
    public addExistPurchaseOrder: boolean;
    public createSeparately: boolean;
}
export class CreatePuchaseOrderBulkCheckQuery extends Common.Query {
    constructor(){
        super('CreatePuchaseOrderBulkCheckQuery',new Common.ModelBinder(PuchaseOrderBulkCheckResult, false));
    }
    public salesOrders: Array<Common.SalesOrder>;
}
export class PuchaseOrderBulkCheckResult extends Common.ObjectBase {
  constructor(){
      super('');
  }
  public hasNoSupplier: boolean;
}


export  class AddPuchaseOrderItemQuery extends Common.Query{
  constructor(){
    super('AddPuchaseOrderItemQuery', new Common.ModelBinder(OrderItem, false));
  }
  public salesOrderItems: Array<Common.OrderItem>;
  public purchaseOrder: Common.Order;
}

export class CreatePuchaseDeliveryQuery extends Common.Query {
    constructor(){
        super('CreatePuchaseDeliveryQuery',new Common.ModelBinder(OrderItem,false));
    }
    public purchaseOrderItems: Array<Common.OrderItem>;
    public pic: string;
    public refNo: string;
    public bookDate: Date;
    public closingDate: Date;
    public dueDate: Date;
    public deliveryFlag: number;
    public scheduledDeliveryDate: Date;
    public deliveryDate: Date;
    public warehouse: Common.Counterpart;
    public salesRefNo: string;
    public receiver: Common.Counterpart;
    public outputReceiverPostalCode: string;
    public outputReceiverAddress1: string;
    public outputReceiverAddress2: string;
    public outputReceiverAddress3: string;
    public outputReceiverName: string;
    public outputReceiverPICSection: string;
    public outputReceiverPIC: string;
    public outputReceiverPICHonorificTitle: string;
    public outputReceiverTelNo: string;
    public outputReceiverFaxNo: string;
    public workflowId :number = 0;
    public actionId :number = 0;
    public invoiceWorkflowId :number = 0;    
    public isTransitPost: boolean = false;
    public exchangeRate: number = 0;
}

export class OrderGetItemPriceQuery extends Common.Query{
  constructor(order:Common.Order, item:Common.OrderItem){
    super('OrderGetItemPriceQuery', new Common.ModelBinder(OrderItem, false));
    this.orderItem = item;
    this.orderItem.order = order;
  }
  public orderItem: Common.OrderItem;
}

export class OrderItemImportQuery extends Common.ImportQuery {
  constructor(sheetName:string, salesPurchaseFlag:number){
    super("",null);
    this.className = "OrderItemImportQuery";
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public sheetName  :string;
  public salesPurchaseFlag : number;
}
export class OrderItemExportQuery extends Common.ExportQuery {
  constructor(sheetName:string, loadQuery:Common.LoadQuery, salesPurchaseFlag:number){
    super("",loadQuery); 
    this.className = "OrderItemExportQuery";
    this.loadQuery = loadQuery;
    this.sheetName = sheetName;
    this.salesPurchaseFlag = salesPurchaseFlag;
  }
  public loadQuery : Common.LoadQuery;
  public sheetName  :string;
  public salesPurchaseFlag : number;
  public hasLicenseCurrency: boolean = false;
}